import StyledAvatar from 'components/StyledAvatar';
import Text from 'components/base/Text';
import validator from 'validator';
import { Flex } from 'components/base/layout-components';
import TextWithTooltipOnEllipsis from 'components/base/TextWithTooltipOnEllipsis';
import Tooltip from '@material-ui/core/Tooltip';
import { LBButton } from '@linearb/buzz';

const EmailNameTooltip = ({ children, name, email }) => (
  <Tooltip
    title={`${name}${email ? ` (${email})` : ''}`}
    disableHoverListener={!name}
  >
    {children}
  </Tooltip>
);
export const ChipComponent = ({ name, email, avatarUrl, unsubscribe }) => (
  <EmailNameTooltip name={name} email={email}>
    <Flex items='center'>
      <StyledAvatar
        size='2.2rem'
        avatar={{ name, email, url: avatarUrl }}
        disableTooltip
      />
      <TextWithTooltipOnEllipsis
        weight={400}
        size='normal'
        ml='0.7rem'
        ellipsisAfter='11.5rem'
        color={unsubscribe && 'silverSand'}
      >
        {name || email}
      </TextWithTooltipOnEllipsis>
    </Flex>
  </EmailNameTooltip>
);

export const EmptyState = ({ searchValue, onAddClick }) => {
  const isValidEmail = validator.isEmail(searchValue);
  return (
    <Flex items='center' justify='center' direction='column' height='100%'>
      <Text
        size='normal'
        align='center'
        width='20.5rem'
        lineHeight='1.6rem'
        weight='14rem'
        italic
        mb='2rem'
      >
        {isValidEmail
          ? 'Would you like to add this email address as a recipient?'
          : 'No results found'}
      </Text>
      {isValidEmail && (
        <LBButton variant='outline' onClick={onAddClick}>
          Add to mailing list
        </LBButton>
      )}
    </Flex>
  );
};

export const ListItem = ({ name, email, avatarUrl, onClick }) => (
  <Flex items='center' onClick={onClick}>
    <EmailNameTooltip name={name} email={email}>
      <Flex items='center'>
        <StyledAvatar
          size='2.2rem'
          avatar={{ name, email, url: avatarUrl }}
          disableTooltip
        />
        <Text ml='1rem' size='medium'>
          {name}
        </Text>
      </Flex>
    </EmailNameTooltip>
  </Flex>
);
